import { useContext } from 'react';
import { SessionContext, Promo } from '@wix/da-react-context/pkg/publicSession';

/** returns the first promo in publicSessions.promos if any */
export function useCurrentPromo(promoType: 'self' | 'gift'): Promo | undefined {
  const { promos } = useContext(SessionContext);
  const currentPromos = promos?.filter(i => i.type === promoType);
  return (
    currentPromos && (currentPromos.length > 0 ? currentPromos?.[0] : undefined)
  );
}
